import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

/**
 * use a fontawesome icon definition to generate a string of svg markup
 * e.g. use in Datepicker custom day content renderer (where you cannot use vue components)
 */
export default function iconAsSvgString(icon: IconDefinition): string {
  const [width, height, , , svgPathData] = icon.icon;

  const isDuotone = icon.prefix === 'fad';
  const paths = Array.isArray(svgPathData) ? svgPathData : [svgPathData];

  return `<svg
    aria-hidden="true"
    focusable="false"
    data-prefix="${icon.prefix}"
    data-icon="${icon.iconName}"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 ${width} ${height}"
    class="svg-inline--fa ${icon.iconName}"
  >
    ${isDuotone ? '<g class="fa-duotone-group">' : ''}
      ${paths
        .map((d, index) => {
          const isSecondary = isDuotone && index === 1;
          return `<path
            fill="currentColor"
            d="${d}"
            class="${isSecondary ? 'fa-secondary' : ''}"
          ></path>`;
        })
        .join('')}
    ${isDuotone ? '</g>' : ''}
  </svg>`;
}
